export const safeJsonParse = <T>(str: string, fallback: T): T => {
    try {
        return JSON.parse(str)
    } catch (error) {
        console.error(`Can't parse json ${str} with error: ${error}`)
        return fallback
    }
}
